export const RESET_CLUB_MEMBERSHIP_ISFETCHING =
  'RESET_CLUB_MEMBERSHIP_ISFETCHING';
export const CLUB_MEMBERSHIP_OBJECT_REQUESTING =
  'CLUB_MEMBERSHIP_OBJECT_REQUESTING';
export const CLUB_MEMBERSHIP_LIST_REQUESTING =
  'CLUB_MEMBERSHIP_LIST_REQUESTING';
export const GET_CLUB_MEMBERSHIP_REQUEST = 'GET_CLUB_MEMBERSHIP_REQUEST';
export const GET_CLUB_MEMBERSHIP_SUCCESS = 'GET_CLUB_MEMBERSHIP_SUCCESS';
export const LIST_CLUB_MEMBERSHIPS_REQUEST = 'LIST_CLUB_MEMBERSHIPS_REQUEST';
export const LIST_CLUB_MEMBERSHIPS_SUCCESS = 'LIST_CLUB_MEMBERSHIPS_SUCCESS';
export const CLUB_MEMBERSHIP_REQUESTING = 'CLUB_MEMBERSHIP_REQUESTING';
export const EDIT_CLUB_MEMBERSHIP_REQUEST = 'EDIT_CLUB_MEMBERSHIP_REQUEST';
export const CANCEL_CLUB_MEMBERSHIP_REQUEST = 'CANCEL_CLUB_MEMBERSHIP_REQUEST';

export const ADD_CLUB_MEMBERSHIP_HOLD_REQUEST =
  'ADD_CLUB_MEMBERSHIP_HOLD_REQUEST';
export const EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST =
  'EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST';
